const types = {
  getChannel: 'channel/GET_CHANNEL',
  getChannelSuccess: 'channel/GET_CHANNEL_SUCCESS',
  getChannelFailure: 'channel/GET_CHANNEL_FAILURE',

  subscribeToChannel: 'channel/SUBSCRIBE_TO_CHANNEL',
};

export default types;
